<template>
  <base-modal
    :reference="'bulkEditPickup'"
    :title="'Editar parada de todos los hoteles'"
    :acceptAction="acceptAction"
    :cancelActionText="'Cerrar'"
    :size="'lg'"
  >
    <template v-slot:cancel-action>
        <div></div>
    </template>
    <template v-slot:body v-if="show">
        <div>
            <p>
                Asignar la misma parada a <strong>TODOS los hoteles</strong> para el grupo de actividad <strong>{{groupBulkPickupEdit.suprazone.name}} / {{groupBulkPickupEdit.activity_group.name}}</strong> 
            </p>
            <p>
                Cualquier asignación previa de un hotel para este grupo de actividad será reemplazada
            </p>
        </div>
        <div class="d-flex w-100 my-3">
            <div class="d-flex flex-column align-items-sm-baseline">
                <label for="">Seleccionar parada a asignar</label>
            <v-select
                :options="geopointsListAdmin.filter(entry => entry.is_pickup).filter(entry => entry.sub_zone.pickup_zone.supra_zone.id == groupBulkPickupEdit.suprazone.id).sort((a,b) => a.name.toLowerCase() > b.name.toLowerCase() ? 1: -1)"
                :reduce="(option) => option.id"
                label="name"
                v-model="form.pickup_id"
                style="width: 17vw"
                class="border"
            >
            </v-select>
            </div>
        </div>
        <div>
            <span v-if="isDataLoading" class="badge badge-danger my-2 badge-loading">
                <i class="fa fa-spinner fa-spin mx-2 my-1"></i>
                Petición en proceso... espere por favor, puede tardar un poco... Al finalizar el proceso se cerrará el popup automáticamente
            </span>
        </div>
    </template>
    
  </base-modal>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import BaseModal from "../../Excursions/Booking/Modal/BaseModal";


export default {
  components: {
    BaseModal,
  },
  props: {
        // hotel: {
        //     type: Object,
        //     required: false,
        // },
        // suprazone: {
        //     type: Object,
        //     required: true,
        // }
  },
  data() {
    return {
        show: false,
        submitAllowed: false,
        form: {
            pickup_id: 0,
            activity_group_id: 0,
            suprazone_id: 0
        },
    };
  },
  async mounted() {
    this.$root.$on("bv::modal::show", async (bvEvent, modalId) => {
      const current = "bulkEditPickup";
      
      if (modalId == current) {
          
        this.show = true
        await this.$store.dispatch('geopoints/getAllGeopointsBySuprazone', {suprazone_id: this.groupBulkPickupEdit.suprazone.id}) 
        
        // get data
      }
    });
  },
  beforeDestroy() {
      
  },
  methods: {
    async acceptAction() {
        if ( this.errors ) {
            return 
        }
        
        let data = {
            suprazone_id: this.groupBulkPickupEdit.suprazone.id,
            activity_group_id: this.groupBulkPickupEdit.activity_group.id,
            pickup_id: this.form.pickup_id
        }
        console.log("data to send", data)
        await this.$store.dispatch("hotelStopGroups/setGroupBulkPickupEdit", data)
        this.$bvModal.hide("bulkEditPickup");
    },
  },
  computed: {
        ...mapGetters(['geopointsListAdmin', 'groupBulkPickupEdit', 'isDataLoading']),
        errors() {},
        
        
  },
    watch: {
    }
};
</script>